import React from 'react';
import './Footer.css';
import { PRIVACY_URLS } from '../constants/appConfig';

function Footer() {
  return (
    <footer className="app-footer">
      <ul className="footer-list">
        <li className="footer-item">
          <a
            href="https://www.mytheresa.com/to/service/terms-conditions"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Terms of Use
          </a>
        </li>
        <li className="footer-item">
          <a
            href={PRIVACY_URLS.servicePolicyUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Privacy Policy
          </a>
        </li>
        <li className="footer-item">
          <a
            href="https://www.mytheresa.com/to/service/imprint/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Imprint
          </a>
        </li>
      </ul>
    </footer>
  );
}

export default Footer;
